import {useEffect, useState} from "react";
import {withBase} from "../utils/basePath";
import {TailoredMarkdown} from "./TailoredMarkdown";

export function HelpViewer() {
    const [helpContent, setHelpContent] = useState<string>("");

    useEffect(() => {
        const fetchHelpContent = async () => {
            try {
                const response = await fetch(withBase("internal/help/guide"));
                if (!response.ok) {
                    throw new Error(`Failed to fetch help content: ${response.statusText}`);
                }
                const text = await response.text();
                setHelpContent(text);
            } catch (error) {
                console.error("Error fetching help content:", error);
                setHelpContent("<p>Sorry, the help content could not be loaded at this time.</p>");
            }
        }
        fetchHelpContent();
    }, []);

    return <TailoredMarkdown onVersionChange={null} className={"px-8 py-2 max-w-[850px] mx-auto"}>
        {helpContent}
    </TailoredMarkdown>

}